(()=>{
// Ajax cart.js represents cart-level allocations in line_price/discounts in the
// documented response. final_line_price alone contains line discounts only.
// Require independent totals to agree; ambiguous projections never earn gifts.
function ajaxNetLineAmounts(cart){
 const cents=v=>Number.isSafeInteger(v)&&v>=0&&v<=100000000;
 if(!Array.isArray(cart?.items)||!cents(cart.total_price))throw Error('The complete cart total is unavailable.');
 const net=new Map();let total=0;
 for(const l of cart.items){
  if(typeof l.key!=='string'||!l.key||net.has(l.key)||!cents(l.original_line_price)||!cents(l.final_line_price)||
    !cents(l.line_price)||!cents(l.total_discount)||!Array.isArray(l.discounts))throw Error('Complete line allocations are required.');
  let discounts=0;
  for(const d of l.discounts){if(!cents(d.amount))throw Error('A line discount is unavailable.');discounts+=d.amount;}
  if(!cents(discounts)||discounts!==l.total_discount||l.original_line_price-discounts!==l.line_price||
    l.line_price>l.final_line_price||l.final_line_price>l.original_line_price)throw Error('Line discount totals do not agree.');
  if(l.line_level_total_discount!==undefined&&l.line_level_total_discount!==l.original_line_price-l.final_line_price)
    throw Error('Line level discount projection is inconsistent.');
  net.set(l.key,l.line_price);total+=l.line_price;
 }
 if(!cents(total)||total!==cart.total_price)throw Error('Cart allocation totals do not agree.');
 return net;
}

function qualifyingSpend(cart,config){
  const net=ajaxNetLineAmounts(cart),allowed=new Set(config.eligibleProductKey.split(','));
  const gift=String(config.giftVariantId).split('/').at(-1);
  return cart.items.reduce((sum,item)=>sum+(String(item.variant_id)===gift||item.gift_card||item.selling_plan_allocation||item.properties?._bellzi_promotion||!allowed.has(String(item.product_id))?0:net.get(item.key)),0);
}

(() => {
  'use strict';
  let campaign=null,cart=null,queued=false;
  const commerce=JSON.parse(document.querySelector('#BellziCommerceConfig')?.textContent||'{}');
  const money=n=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:'USD',maximumFractionDigits:n%100?2:0}).format(n/100);
  const node=(tag,value)=>{const e=document.createElement(tag);e.textContent=value;return e;};
  const active=()=>campaign?.enabled&&!campaign.stockHold&&campaign.offerId==='halloween-free-treat-2026'&&Date.now()>=Date.parse('2026-10-22T07:00:00Z')&&Date.now()<Date.parse('2026-11-03T08:00:00Z');
  function row(title,message,value,max,kind){
    const wrap=document.createElement('div');wrap.className='bag-rewards__row bag-rewards__row--'+kind;
    const label=node('p',message);label.prepend(node('strong',title+' '));
    const bar=document.createElement('progress');bar.max=max;bar.value=Math.min(max,Math.max(0,value));bar.setAttribute('aria-label',title);bar.setAttribute('aria-valuetext',message);
    wrap.append(label,bar);return wrap;
  }
  function render(){
    queued=false;if(!cart)return;
    document.querySelectorAll('[data-cart-page] .shipping-progress,.drawer-shipping').forEach(panel=>{
      const rows=[];
      if(commerce.shippingEnabled&&commerce.country==='US'&&cart.currency==='USD'&&Number(commerce.threshold)>0){
        const remaining=Math.max(0,commerce.threshold-cart.total_price);
        rows.push(row('Free U.S. shipping',remaining?money(remaining)+' to go':'Threshold reached ✓',cart.total_price,commerce.threshold,'shipping'));
      }
      if(active()&&cart.currency==='USD'){
        try{
          const qualifying=qualifyingSpend(cart,campaign),earned=Math.floor(qualifying/6000),remaining=6000-qualifying%6000;
          const gifts=cart.items.filter(i=>i.properties?._bellzi_promotion===campaign.offerId&&i.line_price===0).reduce((n,i)=>n+i.quantity,0);
          let message=earned?(gifts>=earned?earned+' free '+(earned===1?'gift':'gifts')+' in your bag':'Eligible for '+earned+' free '+(earned===1?'gift':'gifts'))+' · '+money(remaining)+' to your next':money(remaining)+' in eligible items to go';
          rows.push(row('Halloween treat',message,qualifying%6000,6000,'gift'));
        }catch{rows.push(node('p','Refresh your bag to check Halloween gift progress.'));}
      }
      panel.replaceChildren(...rows);panel.hidden=!rows.length;panel.classList.add('bag-rewards');
      if(rows.length){const detail=node('small',active()?'Gift progress counts eligible items after discounts. Selected items excluded. Final eligibility at checkout.':'Final shipping eligibility is confirmed at checkout.');
        if(active()){const a=node('a',' Offer details');a.href=(window.Shopify?.routes?.root||'/')+'products/halloween-free-treat-keychain';detail.append(a);}panel.append(detail);}
    });
  }
  function schedule(){if(!queued){queued=true;queueMicrotask(render);}}
  function readPage(){try{const n=document.querySelector('[data-page-cart]');if(n)cart=JSON.parse(n.textContent);}catch{}schedule();}
  document.addEventListener('bellzi:halloween-config',e=>{campaign=e.detail;document.querySelectorAll('[data-halloween-home],#BellziHalloweenOffer').forEach(e=>e.hidden=!active());schedule();});
  for(const event of ['bellzi:cart-state','bellzi:cart-updated'])document.addEventListener(event,e=>{if(e.detail?.cart){cart=e.detail.cart;schedule();}});
  document.addEventListener('shopify:section:load',readPage);readPage();
})();

})();
